    <textarea class="form-control ts-composer-textarea"
              placeholder="What's on your mind?"
              [(ngModel)]="UserPostsDataContent.PostContent"
              rows="2"
              (keyup)="adjustTextareaHeight($event)">
    </textarea>

    <!-- Container for single and double images -->
    <div *ngIf="mediaUrls.length === 1">
        <div class="image-container-one">
            <div class="media-item">
                <div *ngIf="mediaUrls[0].isVideo; else imageTemplate" class="video-container">
                    <video controls class="img-fluid" style="width: 100%; height: auto; object-fit: cover;" [src]="mediaUrls[0].url">
                        Your browser does not support the video tag.
                    </video>
                </div>
                <ng-template #imageTemplate>
                    <img [src]="!mediaUrls[0].isTenor ? mediaUrls[0].url : (mediaUrls[0].isPlaying ? mediaUrls[0].animatedUrl : mediaUrls[0].previewUrl)"
                         class="img-fluid" style="width: 100%; height: auto; object-fit: cover;" (click)="togglePlay(0)">
                </ng-template>
                <div class="overlay-controls" (click)="togglePlay(0)">
                    <button class="btn position-absolute top-right" (click)="removeMediaItem(0); $event.stopPropagation();">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="103.7934 76.2505 48.4703 47.1893" width="30px" height="30px">
                            <circle cx="13.346" cy="13.768" fill="#333333" opacity="0.1" r="30" style="" transform="matrix(0.807839035987854, 0, 0, 0.7864879369735718, 117.24717843532562, 89.01677533984184)" />
                            <path d="M10.59 12L4.54 5.96l1.42-1.42L12 10.59l6.04-6.05 1.42 1.42L13.41 12l6.05 6.04-1.42 1.42L12 13.41l-6.04 6.05-1.42-1.42L10.59 12z" transform="matrix(1, 0, 0, 1, 116.04206848144531, 89.35821533203125)" />
                        </svg>
                    </button>
                    <!-- Toggle Play/Pause if the URL is from Tenor -->
                    <button *ngIf="mediaUrls[0].isTenor && !mediaUrls[0].isPlaying" class="btn play-btn position-absolute center">
                        <svg viewBox="0 0 60 61" aria-hidden="true" class="play-icon">
                            <g>
                                <circle cx="30" cy="30.4219" fill="#333333" opacity="0.3" r="30"></circle>
                                <path d="M22.2275 17.1971V43.6465L43.0304 30.4218L22.2275 17.1971Z" fill="white"></path>
                            </g>
                        </svg>
                    </button>
                    <!-- No visual indicator for pause; clicking the image itself toggles play/pause -->
                    <button *ngIf="mediaUrls[0].isTenor && mediaUrls[0].isPlaying" class="btn play-btn position-absolute center">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="106.8031 109.2966 416 416" width="50px" height="50px">
                            <g transform="matrix(1, 0, 0, 1, 58.80305480957031, 61.29664230346679)">
                                <path d="M256,48C141.31,48,48,141.31,48,256s93.31,208,208,208,208-93.31,208-208S370.69,48,256,48ZM224,320a16,16,0,0,1-32,0V192a16,16,0,0,1,32,0Zm96,0a16,16,0,0,1-32,0V192a16,16,0,0,1,32,0Z" style="fill:#333333; opacity:0.1" />
                            </g>
                        </svg>
                    </button>
                </div>
            </div>
            <p class="caption" *ngIf="mediaUrls[0].isTenor">via <a href="https://tenor.com">TENOR</a></p>
        </div>
    </div>

    <!-- Carousel for two or more images -->
    <div *ngIf="mediaUrls.length > 1" class="carousel-container position-relative">
        <p-carousel [value]="mediaUrls" numVisible="2" numScroll="1" [circular]="true" [responsiveOptions]="responsiveOptions"
                    [ngClass]="{'left': isAtStart, 'right': isAtEnd}" (onPage)="updateActiveIndex($event)"
                    (click)="onCarouselClick($event)">
                <ng-template let-item pTemplate="item">
                    <div class="carousel-item-wrapper">
                        <div class="image-container">
                            <div *ngIf="item.isVideo; else imageTemplate" class="video-container">
                                <video controls class="img-fluid" [src]="item.url">
                                    Your browser does not support the video tag.
                                </video>
                            </div>
                            <ng-template #imageTemplate>
                                <img [src]="item.isTenor ? (item.isPlaying ? item.animatedUrl : item.previewUrl) : item.url" class="img-fluid" alt="Dynamic image" (click)="togglePlay(item.index)">
                            </ng-template>
                            <button class="btn position-absolute top-right" style="z-index:10;" (click)="removeMediaItem(item.index); $event.stopPropagation();">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="103.7934 76.2505 48.4703 47.1893" width="30px" height="30px">
                                    <circle cx="13.346" cy="13.768" fill="#333333" opacity="0.1" r="30" style="" transform="matrix(0.807839035987854, 0, 0, 0.7864879369735718, 117.24717843532562, 89.01677533984184)" />
                                    <path d="M10.59 12L4.54 5.96l1.42-1.42L12 10.59l6.04-6.05 1.42 1.42L13.41 12l6.05 6.04-1.42 1.42L12 13.41l-6.04 6.05-1.42-1.42L10.59 12z" transform="matrix(1, 0, 0, 1, 116.04206848144531, 89.35821533203125)" />
                                </svg>
                            </button>
                            <div *ngIf="item.isTenor" class="overlay-controls" (click)="togglePlay(item.index)">
                                <button *ngIf="!item.isPlaying" class="btn play-btn position-absolute center">
                                    <svg viewBox="0 0 60 61" aria-hidden="true" class="play-icon">
                                        <g>
                                            <circle cx="30" cy="30.4219" fill="#333333" opacity="0.3" r="30"></circle>
                                            <path d="M22.2275 17.1971V43.6465L43.0304 30.4218L22.2275 17.1971Z" fill="white"></path>
                                        </g>
                                    </svg>
                                </button>
                                <!-- No visual indicator for pause; clicking the image itself toggles play/pause -->
                                <button *ngIf="item.isPlaying" class="btn play-btn position-absolute center">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="106.8031 109.2966 416 416" width="50px" height="50px">
                                        <g transform="matrix(1, 0, 0, 1, 58.80305480957031, 61.29664230346679)">
                                            <path d="M256,48C141.31,48,48,141.31,48,256s93.31,208,208,208,208-93.31,208-208S370.69,48,256,48ZM224,320a16,16,0,0,1-32,0V192a16,16,0,0,1,32,0Zm96,0a16,16,0,0,1-32,0V192a16,16,0,0,1,32,0Z" style="fill:#333333; opacity:0.1" />
                                        </g>
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                    <p *ngIf="item.isTenor" class="caption">via <a href="https://tenor.com">TENOR</a></p>
                </ng-template>
            </p-carousel>
</div>

